import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { PanelDeAcceso } from './panel-de-acceso';
import type { TipoDeCotizacion } from '../services/quote-access.service';

interface Props {
  abierto: boolean;
  onCerrar: () => void;
  quoteId: string;
  tipo: TipoDeCotizacion;
}

/**
 * El bloque «Acceso» en un diálogo.
 *
 * Las pantallas del Pricer Datec y del Pricer Solar están armadas con estilos
 * propios y no con las tarjetas del resto de la aplicación: meterles el panel
 * en el medio del layout rompería el acomodo. Un diálogo se apoya en el botón
 * que ya existe al lado de «Versiones» y no toca nada más.
 */
export function DialogoDeAcceso({ abierto, onCerrar, quoteId, tipo }: Props) {
  return (
    <Dialog open={abierto} onOpenChange={(v) => !v && onCerrar()}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Acceso</DialogTitle>
          <DialogDescription>
            Quién ve esta cotización, y de dónde le viene el acceso.
          </DialogDescription>
        </DialogHeader>
        <PanelDeAcceso quoteId={quoteId} tipo={tipo} />
      </DialogContent>
    </Dialog>
  );
}

export default DialogoDeAcceso;
